module.exports = __webpack_public_path__ + "media/bootstrap-icons/grid-1a5034a0.svg";